import React, { useMemo, useState } from 'react'
import './profile.scss'

/**
 * Web Referral mini card (compact)
 * - reads code from user.referralCode (fallback to user.generatedUserId)
 * - click code to copy
 * - Share (Web Share API) with fallback to copy full message
 * - Copy link button
 */
const ReferralSection = ({ user }) => {
  const code = useMemo(
    () => (user?.referralCode || user?.generatedUserId || '').toString(),
    [user]
  )

  const [copied, setCopied] = useState(false)
  const [shared, setShared] = useState(false)

  // Build a share URL (tweak to your actual route/domain if needed)
  const shareUrl = useMemo(() => {
    const base = (window?.ENV && window.ENV.REFERRAL_BASE_URL) || window.location.origin
    return `${base}/ref/${code}`
  }, [code])

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text)
    } catch {
      // fallback for older browsers
      const ta = document.createElement('textarea')
      ta.value = text
      document.body.appendChild(ta)
      ta.select()
      document.execCommand('copy')
      document.body.removeChild(ta)
    }
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  const onShare = async () => {
    const text = `Use my InCash referral code: ${code}\n${shareUrl}`
    try {
      if (navigator.share) {
        await navigator.share({ title: 'InCash Referral', text, url: shareUrl })
        setShared(true)
        setTimeout(() => setShared(false), 1500)
      } else {
        await copy(text) // fallback: copy the message
      }
    } catch {
      // user cancelled or not supported; no-op
    }
  }

  if (!code) return null

  return (
    <div className="referral-section">
      <div className="referral-card">
        <div className="referral-label">Your referral code</div>

        <button
          className="referral-code"
          onClick={() => copy(code)}
          aria-label="Copy referral code"
          type="button"
        >
          <span className="code">{code}</span>
          <span className="copy">Copy</span>
          {copied && <span className="copied">Copied!</span>}
        </button>

        {/* <div className="referral-actions">
          <button className="btn btn-outline-primary" type="button" onClick={onShare}>
            Share
          </button>
          <button className="btn btn-light" type="button" onClick={() => copy(shareUrl)}>
            Copy link
          </button>
        </div> */}

        <div className="referral-hint">
          Click the code to copy. Sharing may unlock extra benefits.
        </div>
      </div>
    </div>
  )
}

export default ReferralSection
